import React from "react";
import { useDocument } from "../hooks/useDocument";

const DEFAULTS = {
  contactAddress:
    "สถาบันวิจัยพืชสวน กรมวิชาการเกษตร\nเลขที่ 50 ถ.พหลโยธิน แขวงลาดยาว เขตจตุจักร กรุงเทพมหานคร 10900",
  contactEmail: "thaicoconut.org@gmail.com",
  contactPhone: "02-579-0583 หรือ 02-940-5484-5",
  facebookEmbedUrl:
    "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D100064619806537&tabs=timeline&width=500&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3873.8720515833375!2d100.57090565592827!3d13.846717870328215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29ce074e9c015%3A0x4a469748614d613c!2z4Liq4LiW4Liy4Lia4Lix4LiZ4Lin4Li04LiI4Lix4Lii4Lie4Li34LiK4Liq4Lin4LiZ!5e0!3m2!1sth!2sth!4v1743471767035!5m2!1sth!2sth",
};

const Contact = () => {
  const { data } = useDocument("settings", "site");
  const s = { ...DEFAULTS, ...(data || {}) };

  return (
    <section id="contact" className="contact">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Contact Us</h2>
          <p>ช่องทางติดต่อและติดตามข่าวสาร</p>
        </div>

        <div className="row">
          <div
            className="col-lg-5 d-flex align-items-stretch"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div
              className="info"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <iframe
                src={s.facebookEmbedUrl}
                style={{
                  width: "500px",
                  maxWidth: "100%",
                  height: "500px",
                  border: "none",
                  overflow: "hidden",
                }}
                allowFullScreen
                allow="encrypted-media"
                title="Facebook Page"
              ></iframe>
            </div>
          </div>
          <div className="col-lg-7 mt-5 mt-lg-0" data-aos="fade-up" data-aos-delay="200">
            <div className="info">
              <div className="address">
                <i className="bi bi-geo-alt"></i>
                <h4>Location:</h4>
                <p style={{ whiteSpace: "pre-line" }}>{s.contactAddress}</p>
              </div>

              <div className="email">
                <i className="bi bi-envelope"></i>
                <h4>Email:</h4>
                <p>{s.contactEmail}</p>
              </div>

              <div className="phone">
                <i className="bi bi-phone"></i>
                <h4>Call:</h4>
                <p>{s.contactPhone}</p>
              </div>

              <iframe
                src={s.mapEmbedUrl}
                frameBorder="0"
                style={{ border: 0, width: "100%", height: "290px" }}
                allowFullScreen
                title="Google Maps"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
